import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import './Appointment.scss';

import SectionTitle from '../../components/SectionTitle/SectionTitle';
import ContactForm from '../../components/ContactForm/ContactForm';

const Appointment = () => {
    const { t } = useTranslation();

    const [mapConsent, setMapConsent] = useState(false);

    useEffect(() => {
        const checkConsent = () => {
            const savedConsent =
                localStorage.getItem('cookieConsent');

            if (!savedConsent) {
                setMapConsent(false);
                return;
            }

            try {
                const settings = JSON.parse(savedConsent);

                setMapConsent(
                    settings.googleMaps === true
                );
            } catch (error) {
                console.error(
                    'Cookie consent error:',
                    error
                );

                setMapConsent(false);
            }
        };

        checkConsent();

        window.addEventListener(
            'cookieConsentChanged',
            checkConsent
        );

        return () => {
            window.removeEventListener(
                'cookieConsentChanged',
                checkConsent
            );
        };
    }, []);

    const mapLink =
        'https://www.google.com/maps?q=Elverdisser+Straße+42+33729+Bielefeld&output=embed';

    return (
        <section
            className="appointment-section pb-70"
            data-aos="fade-up"
            data-aos-duration="2000"
        >
            <div className="container">
                <div className="row align-items-center">

                    {/* GOOGLE MAP */}

                    <div className="col-lg-5 col-md-6">
                        <div className="google-map">

                            {mapConsent ? (
                                <iframe
                                    title="Google Maps"
                                    src={mapLink}
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                />
                            ) : (
                                <div className="google-map-placeholder">
                                    <div className="map-content">

                                        <h3>
                                            {t('appointment.map.title')}
                                        </h3>

                                        <p>
                                            {t('appointment.map.description')}
                                        </p>

                                        <a
                                            href="/cookie-einstellungen"
                                            className="map-cookie-link"
                                        >
                                            {t('appointment.map.cookieSettings')}
                                        </a>

                                    </div>
                                </div>
                            )}

                        </div>
                    </div>

                    {/* CONTACT FORM */}

                    <div className="col-lg-7 col-md-6">
                        <div className="appointment-form-area">

                            <SectionTitle
                                subTitle={t('appointment.form.subTitle')}
                                title={t('appointment.form.title')}
                                description={t(
                                    'appointment.form.description'
                                )}
                            />

                            <ContactForm />

                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default Appointment;